import { CategoryCodeInfo } from '@app-types/plan';

import { PlanTypeId } from '@constants/plan';

import { EligibilityOffer } from './eligibility-offer';

export function sortOffersWithCategoryOrder(
    categories: CategoryCodeInfo[],
    offers: EligibilityOffer[] = [],
): EligibilityOffer[] {
    const result: EligibilityOffer[] = [];

    categories.forEach((category) => {
        const offer = offers.find((offer) => {
            return (
                offer.rangeNg === category.rangeNg &&
                offer.commercialSeries === category.commercialSeries &&
                offer.technology === category.technology
            );
        });

        if (offer) {
            result.push(offer);
        }
    });

    return result;
}

export function getOffersByCategories(
    offers: EligibilityOffer[],
    categoriesCodes: CategoryCodeInfo[],
    shortListOffer?: EligibilityOffer,
) {
    const categories: { [key in PlanTypeId]?: { hasHat: boolean; offers: EligibilityOffer[] } } = {
        [PlanTypeId.FAI_BOX_INTERNET]: { hasHat: false, offers: [] },
        [PlanTypeId.FAI_5GBOX]: { hasHat: false, offers: [] },
        [PlanTypeId.FAI_PUREBYOU]: { hasHat: false, offers: [] },
    };

    offers.forEach((offer) => {
        if (offer.isHidden || offer.sku === shortListOffer?.sku) return;
        offer.categories.forEach((category) => {
            if (categories[category]) {
                categories[category].offers.push(offer);
                if (offer.hat) categories[category].hasHat = true;
            }
        });
    });

    Object.keys(categories).forEach((categoryKey) => {
        const key = categoryKey as keyof typeof categories;
        categories[key]!.offers = sortOffersWithCategoryOrder(categoriesCodes, categories[key]!.offers);
    });

    return categories;
}
